import React, { useState } from 'react';
import LanguageSelect from './LanguageSelect';

const LanguageChangeMarkersPanel = ({
  markers,
  onAddMarker,
  currentTimeSeconds,
  languages,
  disabled = false,
}) => {
  const [markerLanguage, setMarkerLanguage] = useState('');

  const formatOffset = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleAdd = () => {
    if (!markerLanguage) return;
    onAddMarker({
      id: `marker_${Date.now()}`,
      timestamp_seconds: currentTimeSeconds,
      new_language: markerLanguage,
    });
    setMarkerLanguage('');
  };

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 space-y-3">
      <div>
        <p className="text-sm font-medium text-legal-900">Language change markers</p>
        <p className="text-xs text-legal-600 mt-1">
          Mark when the proceeding switches language without stopping the recording.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-2 sm:items-end">
        <div className="flex-1">
          <LanguageSelect
            id="marker-language"
            label="New language at current time"
            value={markerLanguage}
            onChange={setMarkerLanguage}
            languages={languages}
            required={false}
            disabled={disabled}
          />
        </div>
        <button
          type="button"
          onClick={handleAdd}
          disabled={disabled || !markerLanguage}
          className="px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Add marker at {formatOffset(currentTimeSeconds)}
        </button>
      </div>

      {markers.length > 0 && (
        <ul className="space-y-1 max-h-28 overflow-y-auto">
          {markers.map((marker) => (
            <li
              key={marker.id}
              className="text-xs text-legal-700 bg-white rounded px-2 py-1 border border-amber-100"
            >
              <span className="font-mono text-legal-900">{formatOffset(marker.timestamp_seconds)}</span>
              {' → '}
              <span className="font-medium">{marker.new_language}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageChangeMarkersPanel;
